import { render, staticRenderFns } from "./GExamListDeadlineInput.vue?vue&type=template&id=7980925c&scoped=true&"
import script from "./GExamListDeadlineInput.vue?vue&type=script&lang=ts&"
export * from "./GExamListDeadlineInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980925c",
  null
  
)

export default component.exports